import {Button} from '@/components/ui/button/Button'
import styled, {css} from 'styled-components'

export const StyledAgendaButtonFilterSelection = styled(Button)<{$isSelected: boolean}>(
    ({theme: {palette}, $isSelected}) => css`
        width: 100%;
        justify-content: flex-start;
        color: ${palette.neutral['600']};
        outline: 1px solid transparent;
        font-weight: 400;
        &:hover {
            & button {
                color: ${palette.neutral['900']};
            }
        }
        ${$isSelected &&
        css`
            background-color: ${palette.primary['50']};
            outline: 1px solid ${palette.primary['500']};
        `}
    `
)
